import React from "react";
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";

interface FetchConfirmDialogProps {
  open: boolean;
  hasManuallyAddedRows: boolean;
  rowCount: number;
  onConfirm: () => void;
  onCancel: () => void;
}

export const FetchConfirmDialog: React.FC<FetchConfirmDialogProps> = ({
  open,
  hasManuallyAddedRows,
  rowCount,
  onConfirm,
  onCancel,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth>
      <DialogTitle>{t("paygap.employeeData.dialog.confirmFetch.title")}</DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ mb: 2 }}>
          {t("paygap.employeeData.dialog.confirmFetch.message")}
        </Typography>
        {hasManuallyAddedRows && (
          <Alert severity="warning" sx={{ mb: 2 }}>
            <Typography variant="body2">
              <strong>{t("paygap.employeeData.dialog.confirmFetch.warning")}</strong>{" "}
              {t("paygap.employeeData.dialog.confirmFetch.warning", {
                count: rowCount,
              })}
            </Typography>
          </Alert>
        )}
        <Typography variant="body2" sx={{ mb: 2 }}>
          <strong>{t("paygap.employeeData.dialog.confirmFetch.important")}</strong>
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {t("paygap.employeeData.dialog.confirmFetch.note")}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="secondary">
          {t("paygap.employeeData.dialog.confirmFetch.cancel")}
        </Button>
        <Button onClick={onConfirm} variant="contained" color="primary">
          {t("paygap.employeeData.dialog.confirmFetch.confirm")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
